/* lyvoi-cart-back-fix.js — 手机端后退键关购物车抽屉，而不是离开产品页。
   2026-09-07 加。病因：主题 CartDrawer 的 open()/close() 完全不碰 history，
   抽屉不算一个历史步骤 → 加购后按后退直接跳走（实测：首页→PDP→加购→后退，落到首页）。
   做法：只包 open/close 原型方法 + 监听 popstate，不改主题任何现有文件。 */
(function () {
  function init() {
    var CD = customElements.get('cart-drawer');
    if (!CD || CD.__lyvoiBackFix) return;
    CD.__lyvoiBackFix = true;

    var _open = CD.prototype.open;
    var _close = CD.prototype.close;
    var MARK = 'lyvoiCartDrawer';

    CD.prototype.open = function () {
      var r = _open.apply(this, arguments);
      try {
        if (!(history.state && history.state[MARK])) {
          var s = {}; s[MARK] = true;
          history.pushState(s, '', location.href);
        }
      } catch (e) {}
      return r;
    };

    CD.prototype.close = function () {
      var marked = false;
      try { marked = !!(history.state && history.state[MARK]); } catch (e) {}
      var r = _close.apply(this, arguments);
      if (marked) { try { history.back(); } catch (e) {} }
      return r;
    };

    window.addEventListener('popstate', function () {
      var el = document.querySelector('cart-drawer');
      if (el && el.classList.contains('active')) {
        _close.call(el);   // 只关抽屉，不再动 history（否则会连退两步）
      }
    });
  }

  if (customElements.get('cart-drawer')) init();
  else if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(init).catch(function () {});
  }
})();
